const PaymentActions = {
  CREATE_INTENT: 'create_intent',
  AUTHORIZE: 'authorize',
  GET_INTENT: 'verify_intent',
  INVALIDATE_INTENT: 'invalidate_intent',
  CAPTURE: 'capture',
  REFUND: 'refund',
  UNBLOCK: 'unblock'
}
PaymentIntentStates = {
  REQUIRES_CONFIRMATION: 'requires_confirmation',
  REQUIRES_CAPTURE: 'requires_capture',
  PROCESSING: 'processing',
  CANCELLED: 'cancelled',
  SUCCEEDED: 'succeeded'
}
const PaymentProviders = {
  PAYPAL: 'paypal',
  STRIPE: 'stripe'
}
const PaymentIntentModes = {
  CAPTURE: 'capture',
  AUTHORIZE: 'authorize'
}
module.exports = {
  PaymentIntentStates,
  PaymentActions,
  PaymentProviders,
  PaymentIntentModes
}